import * as React from 'react';

import * as styles from './AsideSection.css';

export const AsideSection = (props: React.PropsWithChildren<{}>): React.JSX.Element => {
  return <div className={styles['section']}>{props.children}</div>;
};
